import React, { useEffect, useState } from 'react';
import { submitPhiAttestation } from '../api/profile';
import { PHI_ATTESTATION_VERSION } from '../consent/versions';

function newSessionId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `sess-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export default function PhiAttestationSection({ required, onAccepted, compact = false }) {
  const [checked, setChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [accepted, setAccepted] = useState(!required);

  useEffect(() => {
    setAccepted(!required);
  }, [required]);

  async function handleSave() {
    if (!checked) {
      setError('Please confirm the attestation to continue.');
      return;
    }
    setError(null);
    setSubmitting(true);
    try {
      await submitPhiAttestation({
        attestationVersion: PHI_ATTESTATION_VERSION,
        calculatorSessionId: newSessionId(),
      });
      setAccepted(true);
      if (typeof onAccepted === 'function') onAccepted();
    } catch (err) {
      setError(err?.code || err?.message || 'phi_attestation_failed');
    } finally {
      setSubmitting(false);
    }
  }

  if (accepted && !required) {
    return (
      <p style={okStyle} data-testid="phi-attestation-status-ok">
        Data-entry attestation is up to date for this version.
      </p>
    );
  }

  return (
    <div style={compact ? undefined : sectionStyle} data-testid="phi-attestation-section">
      {!compact && (
        <p style={ledeStyle}>
          Required before you enter valuation inputs or save new valuations. You can update this here
          whenever the attestation text changes.
        </p>
      )}
      <label style={checkRowStyle}>
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          data-testid="phi-attestation-checkbox"
        />
        <span>
          I confirm that the information I enter into this tool does not include protected health
          information (PHI) or other patient-identifiable data, unless expressly permitted under a
          separate agreement with LooporaData.
        </span>
      </label>
      {error && <p style={errorStyle}>{error}</p>}
      <button
        type="button"
        style={saveBtnStyle}
        disabled={submitting}
        onClick={handleSave}
        data-testid="phi-attestation-save"
      >
        {submitting ? 'Saving…' : 'Save attestation'}
      </button>
    </div>
  );
}

const sectionStyle = { marginTop: '4px' };
const ledeStyle = { fontSize: '12px', color: 'var(--ink2)', lineHeight: 1.5, margin: '0 0 10px' };
const checkRowStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  fontSize: '12px',
  color: 'var(--ink2)',
};
const errorStyle = { fontSize: '12px', color: 'var(--error)', margin: '8px 0 0' };
const okStyle = { fontSize: '12px', color: 'var(--ink2)', margin: '4px 0 0' };
const saveBtnStyle = {
  marginTop: '10px',
  padding: '8px 14px',
  borderRadius: '999px',
  border: 'none',
  background: 'var(--accent)',
  color: '#fff',
  fontSize: '12px',
  cursor: 'pointer',
  fontFamily: 'var(--font)',
};
